import moment from "moment";
import isObjectEmpty from "./isObjectEmpty";

export default function tokenValidate() {
  try {
    const token: Record<string, any> = JSON.parse(
      localStorage.getItem("token") ?? "{}"
    );
    if (isObjectEmpty(token) || !token.value) {
      return { loggedIn: false, expired: false };
    }
    const stillValid = moment(token.expiry).isAfter(moment());
    if (!stillValid) {
      localStorage.removeItem("token");
      return { loggedIn: false, expired: true };
    }
    return { loggedIn: true, expired: false };
  } catch {
    localStorage.removeItem("token");
    return { loggedIn: false, expired: false };
  }
}
